module.exports = __webpack_public_path__ + "mp.514261821eb257fc8c85.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/mp.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/mp.svg
// module chunks = styles